import { Controller } from "@hotwired/stimulus"

const TAB_KEYS = ["general", "branding", "navigation", "colors", "advanced"]
const UNSAVED_MESSAGE = "You have unsaved changes. Leave anyway?"

export default class extends Controller {
  static targets = ["tab", "panel"]

  connect() {
    this.dirty = false
    this.form = this.element.closest("form")

    this.onHashChange = this.onHashChange.bind(this)
    this.markDirty = this.markDirty.bind(this)
    this.markClean = this.markClean.bind(this)
    this.guardUnload = this.guardUnload.bind(this)
    this.guardVisit = this.guardVisit.bind(this)

    window.addEventListener("hashchange", this.onHashChange)
    window.addEventListener("beforeunload", this.guardUnload)
    document.addEventListener("turbo:before-visit", this.guardVisit)

    if (this.form) {
      this.form.addEventListener("input", this.markDirty)
      this.form.addEventListener("change", this.markDirty)
      this.form.addEventListener("turbo:submit-end", this.markClean)
    }

    this.activate(this.keyFromHash() || "general")
  }

  disconnect() {
    window.removeEventListener("hashchange", this.onHashChange)
    window.removeEventListener("beforeunload", this.guardUnload)
    document.removeEventListener("turbo:before-visit", this.guardVisit)
    if (this.form) {
      this.form.removeEventListener("input", this.markDirty)
      this.form.removeEventListener("change", this.markDirty)
      this.form.removeEventListener("turbo:submit-end", this.markClean)
    }
  }

  select(event) {
    const key = event.currentTarget.dataset.tab
    if (!TAB_KEYS.includes(key)) return
    this.activate(key)
    history.replaceState(null, "", `#${key}`)
  }

  activate(key) {
    this.tabTargets.forEach((tab) => {
      const active = tab.dataset.tab === key
      tab.classList.toggle("text-blue-700", active)
      tab.classList.toggle("dark:text-blue-400", active)
      tab.classList.toggle("border-blue-600", active)
      tab.classList.toggle("border-transparent", !active)
      tab.classList.toggle("text-gray-600", !active)
      tab.classList.toggle("dark:text-gray-400", !active)
      tab.setAttribute("aria-selected", active ? "true" : "false")
    })
    this.panelTargets.forEach((panel) => {
      const active = panel.dataset.tab === key
      panel.toggleAttribute("hidden", !active)
    })
  }

  keyFromHash() {
    const hash = (window.location.hash || "").replace(/^#/, "")
    return TAB_KEYS.includes(hash) ? hash : null
  }

  onHashChange() {
    const key = this.keyFromHash()
    if (key) this.activate(key)
  }

  markDirty() {
    this.dirty = true
  }

  markClean(event) {
    if (event && event.detail && event.detail.success) this.dirty = false
  }

  guardUnload(event) {
    if (!this.dirty) return
    event.preventDefault()
    event.returnValue = UNSAVED_MESSAGE
  }

  guardVisit(event) {
    if (!this.dirty) return
    if (!window.confirm(UNSAVED_MESSAGE)) event.preventDefault()
  }
}
